import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrandingService, CommonAssociationCardContentComponent, CrmPlatformApiService } from '@galaxy/crm/static';
import { TranslateModule } from '@ngx-translate/core';
import { AddContactAsIamUserForCompanyStatus } from '@vendasta/crm-integrations';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, Subject } from 'rxjs';
import { AccessBusinessAppService } from './access-business-app.service';
import { InviteToBusinessAppComponent } from './invite-to-business-app/invite-to-business-app.component';

@Component({
  selector: 'app-crm-access-business-app',
  templateUrl: './access-business-app.component.html',
  styleUrls: ['./access-business-app.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    CommonAssociationCardContentComponent,
    TranslateModule,
    MatProgressSpinnerModule,
  ],
  providers: [AccessBusinessAppService, BrandingService, CrmPlatformApiService],
  standalone: true,
})
export class AccessBusinessAppComponent implements OnInit {
  lastLogin$: Observable<string>;
  businessAppName$: Observable<string>;
  loading = signal<boolean>(false);

  @Input({ required: true }) companyId: string;
  @Input({ required: true }) contactId: string;
  @Input({ required: true }) contactName: string;
  @Input({ required: true }) companyName: string;
  @Input({ required: true }) hasAccess: boolean;
  @Input({ required: true }) desiredAccess$$: Subject<boolean | null>;

  constructor(
    private readonly platformService: CrmPlatformApiService,
    private readonly snackbarService: SnackbarService,
    private readonly accessBusinessAppService: AccessBusinessAppService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.businessAppName$ = this.accessBusinessAppService.businessAppName$;
    this.lastLogin$ = this.accessBusinessAppService.getLastLogin(this.contactId);
  }

  inviteUserToApp(): void {
    this.dialog
      .open(InviteToBusinessAppComponent, {
        width: '560px',
        data: {
          name: this.contactName,
          companyName: this.companyName,
          businessAppName$: this.businessAppName$,
        },
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.loading.set(true);
          this.accessBusinessAppService.addContactAsIAMUser(this.contactId, this.companyId).subscribe((response) => {
            if (response === AddContactAsIamUserForCompanyStatus.ADD_CONTACT_AS_IAM_USER_FOR_COMPANY_STATUS_SUCCEEDED) {
              // success.  Stop retrying.
              this.loading.set(false);
              this.desiredAccess$$.next(true);
              this.snackbarService.openSuccessSnack('ASSOCIATIONS.APP_ACCESS_MODAL.SUCCESS');
            } else {
              // failure.  Stop retrying.
              this.loading.set(false);
              this.snackbarService.openErrorSnack('ASSOCIATIONS.APP_ACCESS_MODAL.ERROR');
            }
          });
        }
      });
  }
}

export { AccessBusinessAppService };
